import { NavigationType, PermissionTypeEnums } from '@/types'

export const UNAUTH_HOME_PATH: string = '/'
export const PRIVACY_POLICY_PATH: string = '/privacy-policy'
export const PUBLIC_REVIEW_PATH: string = '/public/review'
export const PUBLIC_EVENTS_PATH: string = '/public/appointments'
export const PUBLIC_OFFER_PATH: string = '/public/offer'
export const PUBLIC_INVOICE_PATH: string = '/public/invoice'

export const HOME_PATH: string = '/timeline'
export const HOME_PATH_GUEST: string = '/onboard'
export const APPOINTMENTS_PATH: string = '/appointments'
export const LEADS_PATH: string = '/leads'
export const PATIENTS_PATH: string = '/patients'
export const PATIENTS_SUGGESTIONS_PATH: string = '/patients-suggestions'
export const PATIENT_JOURNEYS_PATH: string = '/patient-journeys'
export const PJ_SUGGESTIONS_PATH: string = '/patient-journeys-suggestions'
export const MESSAGES_PATH: string = '/messages'
export const SUGGESTIONS_PATH: string = '/suggestions'
export const REPORTS_PATH: string = '/reports'
export const INVOICES_PATH: string = '/invoices'
export const PROPOSALS_PATH: string = '/offers'
export const SETTINGS_PATH: string = '/settings'
export const ACTIVITY_REPORT_PATH: string = '/activity-report'
export const MY_WEBSITES_PATH: string = '/my-websites'
export const MY_INVITES_PATH: string = '/my-invitations'
export const USER_ROLES_PATH: string = '/user-roles'
export const PROFILE_PATH: string = '/profile'
export const PROCEDURES_PATH: string = '/procedures'
export const IMPORTS_PATH: string = '/imports'
export const TEMPLATES_PATH: string = '/templates'
export const CALLBACK_PATH: string = '/callback'
export const NOT_FOUND_PATH: string = '/:pathMatch(.*)*'
export const FAQ_PATH: string = '/faqs'
export const INTEGRATIONS_PATH: string = '/integrations'
export const STRIPE_PATH: string = 'stripe'
export const GOOGLE_PATH: string = 'google'
export const GOOGLE_CALLBACK_PATH: string = 'google/callback'
export const MAILCHIMP_PATH: string = 'mailchimp'
export const MAILCHIMP_CALLBACK_PATH: string = 'mailchimp/callback'
export const ZOOM_PATH: string = 'zoom'
export const ZOOM_CALLBACK_PATH: string = 'zoom/callback'

export const MAIN_MENU_ITEMS: NavigationType = {
  Navigation: [
    {
      text: 'Timeline',
      to: HOME_PATH,
      icon: 'QueueListIcon',
    },
    {
      text: 'Appointments',
      to: APPOINTMENTS_PATH,
      icon: 'CalendarDaysIcon',
      permission: PermissionTypeEnums.VIEW_APPOINTMENTS,
    },
    {
      text: 'Leads',
      to: LEADS_PATH,
      icon: 'NewspaperIcon',
    },
    {
      text: 'Patients',
      to: PATIENTS_PATH,
      icon: 'UsersIcon',
      permission: PermissionTypeEnums.VIEW_PATIENTS,
    },
    {
      text: 'Patient Journeys',
      to: PATIENT_JOURNEYS_PATH,
      icon: 'ArchiveBoxIcon',
    },
    {
      text: 'Messages',
      to: MESSAGES_PATH,
      icon: 'ChatBubbleLeftRightIcon',
      permission: PermissionTypeEnums.VIEW_MESSAGES,
    },
    {
      text: 'Suggestions',
      to: SUGGESTIONS_PATH,
      icon: 'LightBulbIcon',
    },
    {
      text: 'Reports',
      to: REPORTS_PATH,
      icon: 'ClipboardDocumentListIcon',
      permission: PermissionTypeEnums.VIEW_MESSAGES,
    },
    {
      text: 'Invoices',
      to: INVOICES_PATH,
      icon: 'CurrencyDollarIcon',
    },
    {
      text: 'Offers',
      to: PROPOSALS_PATH,
      icon: 'DocumentTextIcon',
    },
  ],
  Tools: [
    {
      text: 'Settings',
      to: SETTINGS_PATH,
      icon: 'Cog8ToothIcon',
    },
  ],
}

export const PAGES_WITH_CLINIC_SELECTION: string[] = [
  APPOINTMENTS_PATH,
  ACTIVITY_REPORT_PATH,
  PATIENT_JOURNEYS_PATH,
  INVOICES_PATH,
  PROPOSALS_PATH,
  SUGGESTIONS_PATH,
  // Setting pages
  SETTINGS_PATH,
  USER_ROLES_PATH,
  PROCEDURES_PATH,
  IMPORTS_PATH,
  TEMPLATES_PATH,
  FAQ_PATH,
  INTEGRATIONS_PATH,
  `${INTEGRATIONS_PATH}/${STRIPE_PATH}`,
  `${INTEGRATIONS_PATH}/${GOOGLE_PATH}`,
  `${INTEGRATIONS_PATH}/${MAILCHIMP_PATH}`,
  `${INTEGRATIONS_PATH}/${ZOOM_PATH}`,
]
